export const useStyles = (theme) => ({
  paper: {
    paddingTop: 16,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 24,
    textAlign: "left",
    color: theme.palette.text.secondary,
  },
  gridStyle: {
    cursor: "pointer",
    "&:hover": {
      opacity: 0.7,
    },
  },
  titleTextStyle: {
    fontSize: 25,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#253570",
  },
  textStyle: {
    display: "flex",
    justifyContent: "flex-start",
    alignItems: "center",
  },
  countStyle: {
    fontWeight: "bold",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end",
    color: "#253570",
  },
});
